export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-confirm-box/index.js